import { inputAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys)

const inputBrandStyle = definePartsStyle({
  field: {
    border: '1.5px solid black',
    bg: 'transparent',
    rounded: '1.25rem',
    _placeholder: {
      color: '#7a7a7a',
    },
  },
})

const inputWhiteBrandStyle = definePartsStyle({
  field: {
    bg: 'white',
    rounded: '1.25rem',
    _placeholder: {
      color: '#7a7a7a',
    },
  },
})

const inputGrayBrandStyle = definePartsStyle({
  field: {
    bg: '#f5f5f5',
    rounded: '1.25rem',
    _placeholder: {
      color: '#7a7a7a',
    },
  },
})

export const inputTheme = defineMultiStyleConfig({
  variants: {
    'brand-outline': inputBrandStyle,
    'brand-solid-white': inputWhiteBrandStyle,
    'brand-solid-gray': inputGrayBrandStyle,
  },
})
